module.exports = __webpack_public_path__ + "static/media/annet-liar-tapi-dah-jinak-9skLz_qQLRo-unsplash.20c8d4d4.jpg";